import * as React from "react";
import { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import { DataGrid } from "@mui/x-data-grid";
import Header from "../../components/Header/Header";
import { useSearchParams } from "react-router-dom";
import { getWeeklyWorkersList } from "../../../../api/apiCall";
import { useAuth } from "../../../../auth/auth";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import "./WorkersByWeek.css";
import { SimpleTreeView, TreeItem } from "@mui/x-tree-view";
import { format } from "date-fns";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCalendar,
  faHourglassEnd,
  faHourglassStart,
  faSignsPost,
  faUser,
} from "@fortawesome/free-solid-svg-icons";

// const CustomTooltip = styled(({ className, ...props }: any) => (
//   <Tooltip {...props} classes={{ popper: className }} />
// ))(() => ({
//   [`& .${tooltipClasses.tooltip}`]: {
//     backgroundColor: '#333',
//     color: '#fff',
//     width :'1000px',
//     fontSize: '14px',
//     borderRadius: '4px',
//     padding: '8px 16px',
//     whiteSpace: 'pre-line'
//   },
//   [`& .${tooltipClasses.arrow}`]: {
//     color: '#333',
//   },
// })) 

export default function WorkersList() {
  const { state } = useAuth();
  const [searchParams, setSearchParams] = useSearchParams();
  const [date, setDate] = useState(null);
  const [week, setWeek] = useState<any>(searchParams.get("week") || 1);
  const [year, setYear] = useState<any>(searchParams.get("year") || 2024);
  const [workersList, setWorkersList] = useState<any>([]);
  const [open, setOpen] = useState(false);
  const [shiftDetails, setshiftDetails] = useState<any>([]);

  const getWorkersList = async () => {
    try {
      const response = await getWeeklyWorkersList(
        state.user?.token,
        week,
        year
      );
      setWorkersList(response?.workers);
    } catch (error) {
      console.log(error);
    }
  };

  const processedWorkersList = workersList.map((worker: any) => {
    const shiftDetails = worker.shifts.map((shift: any) => shift);
    return {
      ...worker,
      shiftDetails,
      details: "WKD ...",
    };
  });

  const getShiftDetails = (shiftDetails: any) => {
    setshiftDetails(shiftDetails);
    setOpen(true);
  };

  const columns = [
    {
      field: "fullName",
      headerName: "Full Name",
      flex: 1,
    },
    {
      field: "pts",
      headerName: "PTS",
      flex: 1,
    },
    {
      field: "phoneNumber",
      headerName: "Phone Number",
      flex: 1,
    },
    {
      field: "shiftCount",
      headerName: "Total Shifts",
      flex: 1,
    },
    {
      field: "details",
      headerName: "Shift Details",
      flex: 1,
      renderCell: (params: any) => (
        // <CustomTooltip title={params.row.shiftDetails} arrow>
        //   <span>{params.value}</span>
        // </CustomTooltip>
        <div onClick={() => getShiftDetails(params.row.shiftDetails)}>
          {params.value}
        </div>
      ),
    },
  ];

  useEffect(() => {
    setSearchParams({ year, week }, { replace: true });
    getWorkersList();
  }, [date]);

  return (
    <>
      <Header
        setDate={setDate}
        week={week}
        setWeek={setWeek}
        year={year}
        setYear={setYear}
      />
      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        aria-labelledby="child-modal-title"
        aria-describedby="child-modal-description"
        maxWidth={false}
        sx={{ zIndex: 10000 }}
        slotProps={{ backdrop: { sx: { backgroundColor: "transparent" } } }}
        PaperProps={{
          className: "modal",
          sx: { m: 0, maxWidth: "none", maxHeight: "none" },
        }}
      >
        <DialogContent style={{ whiteSpace: "pre-line" }}>
          {shiftDetails.map((shift: any) => (
            <SimpleTreeView key={shift.jobDate}>
              <TreeItem
                itemId="day"
                label={`${shift.whatsAppName} - ${format(
                  shift.jobDate,
                  "dd/MM/yyyy"
                )}`}
              >
                <div>
                  <h4>Project: </h4>
                  <div>{shift.project}</div>
                  <div className="line"></div>
                  <h4>Details: </h4>
                  <div>
                    {shift.jobDescription ? shift.jobDescription : "Civil Work"}
                  </div>
                  <div className="line marginBottom"></div>
                  <div className="details">
                    <FontAwesomeIcon color="#1e3050" icon={faUser} />
                    <div style={{ marginLeft: "17px" }}>
                      <div className="text">Work Role</div>
                      <div>{shift.workRole}</div>
                    </div>
                  </div>
                  <div className="details">
                    <FontAwesomeIcon color="#1e3050" icon={faCalendar} />
                    <div style={{ marginLeft: "17px" }}>
                      <div className="text">Shift Date</div>
                      <div>
                        {format(shift.jobDate, "EEEE")}{" "}
                        {format(shift.jobDate, "dd/MM/yyyy")}
                      </div>
                    </div>
                  </div>
                  <div className="details">
                    <FontAwesomeIcon color="#1e3050" icon={faHourglassStart} />
                    <div style={{ marginLeft: "17px" }}>
                      <div className="text">Start Time</div>
                      <div>{format(shift.startTime, "HH:mm")}</div>
                    </div>
                  </div>
                  <div className="details">
                    <FontAwesomeIcon color="#1e3050" icon={faHourglassEnd} />
                    <div style={{ marginLeft: "17px" }}>
                      <div className="text">End Time</div>
                      <div>{format(shift.endTime, "HH:mm")}</div>
                    </div>
                  </div>
                  <div className="details">
                    <FontAwesomeIcon color="#1e3050" icon={faSignsPost} />
                    <div style={{ marginLeft: "17px" }}>
                      <div className="text">Location</div>
                      <div>
                        {shift.location} - {shift.postCode}
                      </div>
                    </div>
                  </div>
                  <div className="line marginBottom"></div>
                </div>
              </TreeItem>
            </SimpleTreeView>
          ))}
        </DialogContent>
      </Dialog>
      <Box
        sx={{ height: "850px", width: "80%" }}
        marginTop={11}
        marginLeft={25}
      >
        <DataGrid
          rows={processedWorkersList}
          columns={columns}
          disableRowSelectionOnClick
          getRowId={(row: any) => row.workerId}
          sx={{
            "@media (max-width: 700px)": {
              minWidth: "100%",
            },
            "& .MuiDataGrid-columnHeader": {
              color: "#333",
              fontWeight: "bold",
              fontSize: 15,
              backgroundColor: "#f0f0f0",
            },
            "& .MuiDataGrid-columnHeaderTitle": {
              fontWeight: "bold",
            },
            "@media (max-width: 600px)": {
              fontSize: "0.7rem",
            },
          }}
        />
      </Box>
    </>
  );
}
